<template>
  <v-fade-transition>
    <div>
      <div class="form-fields pa-4 pb-0">
        <form-field
          v-for="(fieldSchema, field) in schema"
          :item="item"
          :schema="fieldSchema"
          :key="field"
          :field="field"
          :value="item.values[field]"
          :lessonId="lessonId"
        />
      </div>
      <done-editing :item="item" :lessonId="lessonId" />
    </div>
  </v-fade-transition>
</template>

<script>
import FormField from './FormField';
import DoneEditing from '@/views/lessons/lessonWidgets/genericWidget/DoneEditing';

export default {
  name: 'FormFields',
  props: ['item', 'lessonId'],
  components: {
    FormField,
    DoneEditing,
  },

  // events should be emited to get the new payload
  // and check for uuid existence and then add into the array
  // that way right?
  computed: {
    definition() {
      return this.$store.getters['items/type'](this.item.type) || {};
    },
    schema() {
      return this.definition.schema;
    },
  },
};
</script>

<style lang="less">
.form-fields {
  .form-group {
    & + .form-group {
      margin-top: 24px;
    }
    h5 {
      margin-bottom: 5px;
    }
  }

  &-edit {
    width: 100%;
  }
}
</style>
